import { render, staticRenderFns } from "./CompanySelector.vue?vue&type=template&id=1023dd24&scoped=true&"
import script from "./CompanySelector.vue?vue&type=script&lang=js&"
export * from "./CompanySelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1023dd24",
  null
  
)

export default component.exports